<template>
	<c-dialog ref="dialog" width="500" mode="slide" mask-close @close="dialogFormEditConfirm($refs.form, arguments)" @resolve="editHandle">
		<c-tips v-if="saasInfo.max_v_account_count>0">员工账号最多可创建{{saasInfo.max_account_count}}个，虚拟账号{{saasInfo.max_v_account_count}}个</c-tips>
		<c-tips v-else>员工账号最多可创建{{saasInfo.max_account_count}}个</c-tips>
		
		<c-form ref="form" vertical unit-width="100%">
			<c-input type="hidden" name="id"></c-input>
            <c-form-item label="账号类型" required :tip="userType==1?'当前商家的员工':'采购供应商的联系人，可关联某个供应商'">
                <c-radio-group v-model="userType" name="user_type" :options="userTypeDic" :disabled="editState"></c-radio-group>
            </c-form-item>
			<c-form-item label="账号" required  tip="只允许包含中文、数字、字母、下划线，长度范围2-30个字符，不允许重复">
				<c-input name="user_name" maxlength="30" :disabled="is_manage"></c-input>
			</c-form-item>
            <c-form-item label="姓名" required  tip="最多输入30个字符">
				<c-input name="user_realname" maxlength="30"></c-input>
			</c-form-item>
			<c-form-item label="手机号码" required tip="请输入11位手机号，不允许重复，手机号可以作为登录凭证，同时也作为通联账户凭证">
				<c-input name="phone" maxlength="11" ></c-input>
			</c-form-item>
			<c-form-item label="采购供应商" required v-show="this.userType == 2">
				<c-select name="supplier_id" async  @search="searchSupplier" :value-data="selectedSupplier"></c-select>
<!--				<template #handle>
                    <c-link icon v-if="auth('b_purchase_supplier_edit')" @click="$refs.purchaseSupplierEdit.open()">创建供应商</c-link>
				</template>-->
			</c-form-item>
			<c-form-item label="部门">
				<c-select name="department_ids" async multiple @search="searchDepartment" :value-data="selectedDepartment"></c-select>
<!--				<template #handle>
                    <c-link icon v-if="auth('b_department_edit')" @click="$refs.departmentEdit.open()">创建部门</c-link>
				</template>-->
			</c-form-item>
			<!--自定义字段控件-->
			<custom-form ref="customForm" work-type="1"></custom-form>
		</c-form>
		
		<!--创建/编辑部门弹窗-->
		<department-edit ref="departmentEdit"></department-edit>
        <!--新增、编辑采购供应商弹窗-->
        <purchase-supplier-edit ref="purchaseSupplierEdit" @resolve="$refs.view.update()"></purchase-supplier-edit>
	</c-dialog>
</template>

<script>
import {mapState, mapGetters} from "vuex";
import departmentEdit from "./department_edit.vue";
import purchaseSupplierEdit from "@/pages/purchase/purchase_supplier_edit.vue";

export default {
    name: 'sysuserEdit',

	components: {
		departmentEdit,purchaseSupplierEdit
	},
    props: {
        client_user_type: [String, Number], //1=员工 2=供应商联系人
        client_department_id: [String, Number], //关联部门名称
        client_supplier_id: [String, Number] //供应商
    },

	data() {
		return {
			editState:false,
            userType:1,         //账号类型
			selectedDepartment:[],
            selectedSupplier:[],
			is_manage:false   //是否超级管理员（1：是，2：否）
		}
	},

	computed: {
		...mapState(['systemConfig', 'userTypeDic', 'saasInfo', 'pricingTypeDic']),
	},

	methods: {
		/*********打开编辑框，初始化；preset_user_type为新建时预置的账号类型（1=员工 2=供应商联系人）**********/
		async open(data, preset_user_type) {
			this.editState = !!data;
			this.is_manage = false;
			this.$refs.form.clear();
			this.$refs.customForm.init();
			if (data) {
				//查询部门详情
				this.request({
					url:'/sys_user/detail',
					data: {
						id:data.id
					},
					success:data => {
						this.$refs.form.set(data.detailInfo);
						this.is_manage = data.detailInfo.is_manage==1?true:false;
						this.userType = data.detailInfo.user_type||1;
						//已选中的[部门]
						this.selectedDepartment = data.departmentList.map(item => {
							return {
								name:item.department_name,
								value:item.id
							}
						});
						//已选中的[采购供应商]
						this.selectedSupplier = [{
                            name:data.detailInfo.supplier_rating + ' | ' +data.detailInfo.supplier_name,
                            value:data.detailInfo.supplier_id
                        }]
					}
				})
			}else if (this.client_user_type == 1 && this.client_department_id){//采购页新增【员工】
                this.$refs.form.set({
                    user_type:this.client_user_type
                });
                //查询部门详情
                this.request({
                    url:'/department/detail',
                    data: {
                        id:this.client_department_id
                    },
                    success:data => {
                        //已选中的用户
                        this.selectedDepartment = [{
                                name:data.detailInfo.department_name,
                                value:data.detailInfo.id
                        }];
                    }
                });
            }else if (this.client_user_type == 2 && this.client_supplier_id){//采购页新增【供应商联系人】
                this.$refs.form.set({
                    user_type:this.client_user_type
                });
                //查询供应商详情
                this.request({
                    url: '/purchase/supplier/detail',
                    data: {
                        id: this.client_supplier_id
                    },
                    success: data => {
                        this.selectedSupplier = [{
                            name:data.supplier.rating + ' | ' +data.supplier.supplier_name,
                            value:data.supplier.id
                        }]
                    }
                })
            }else {
                //列表页新建：按外部预置账号类型自动勾选（如当前视图：员工视图→1、供应商联系人视图→2），未预置则默认员工；同时重置上次打开残留的类型
                this.userType = Number(preset_user_type) === 2 ? 2 : 1;
                this.$refs.form.set({user_type: this.userType});
            }
			//填充form表单
			this.$refs.dialog.open({
				title: this.editState ? '编辑用户' : '创建用户'
			});
		},

		/*******搜索部门*****************/
		searchDepartment(keyword, resolve){
			this.request({
				url:'/system/options',
				data: {
					options_code:'DEPARTMENT',
					keyword:keyword
				},
				success:data => {
					resolve(data);
				}
			})
		},
		/*******搜索采购供应商*****************/
		searchSupplier(keyword, resolve){
			this.request({
				url:'/system/options',
				data: {
					options_code:'SUPPLIER',
					keyword:keyword
				},
				success:data => {
					resolve(data);
				}
			})
		},

		/*******创建、编辑提交处理方法********/
		editHandle (stop, next){
			stop();
			this.$refs.form.submit({
				url: this.editState?'/sys_user/edit':'/sys_user/add',
				rule: {
                    user_type: '请选择账号类型',
					user_name: '请输账号',
					user_realname: '请输姓名',
                    phone: '请输入手机号',
                    supplier_id: [{
                        type: 'empty',
                        message: '请选择关联采购供应商',
                        skip: () => {
                            return this.userType == 1;
                        }
                    }],
					...this.$refs.customForm.rule
				},
				dataFormatter: data => {
            data.custom_fields_value_json = JSON.stringify(data.custom_fields_value_json);
            return data;
				},
				success: (data, res) => {
					next();
					if (this.editState){//编辑
						this.$message({
							message: '编辑成功',  // 提示内容,
							type: 'success'
						});
					}else {//新增
						this.$confirm({
							type: 'success',
							message: res,
							buttonName: '知道了',
							cancelButton: false,
							resolve: () => {
							}
						});
					}
					this.$emit('resolve');
				}
			});
		}
	}
}
</script>

<style lang="stylus" scoped>
</style>